import React, { useEffect, useState, useCallback } from 'react';
import { Col, Button, List, Divider, message } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Api_VariavelGlobal } from '../global';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const PedidosEntrega = () => {
  const [pedidosNovos, setPedidosNovos] = useState([]);
  const [usuarios, setUsuarios] = useState({});
  const [loadingPedido, setLoadingPedido] = useState(null);

const getTipoPagamento = (codigo) =>
    codigo === 1 ? 'Dinheiro' :
    codigo === 2 ? 'Cartão' :
    codigo === 3 ? 'Pix' :
    codigo === 4 ? 'Ifood' :
    codigo === 5 ? 'Pagamento Online' :
    'Indefinido';

  const formatarValor = (valor) => {
    const num = Number(valor);
    return isNaN(num) ? 'R$ 0,00' : `R$ ${num.toFixed(2).replace('.', ',')}`;
  };

const formatarData = (dataISO) => {
  if (!dataISO) return '';

  // Remove o 'Z' final se existir e separa data e hora
  const cleaned = dataISO.replace('Z', '');
  const [data, hora] = cleaned.split('T'); // separa "2025-08-17" e "13:07:41.000"

  if (!data || !hora) return dataISO; // fallback caso formato inesperado

  const [ano, mes, dia] = data.split('-');
  const horaLimpa = hora.split('.')[0]; // remove os milissegundos se existirem

  return `${dia}/${mes}/${ano} ${horaLimpa}`;
};



  const fetchUsuarios = useCallback(async () => {
    try {
      const response = await fetch(`${Api_VariavelGlobal}/api/users`);
      if (!response.ok) throw new Error('Erro ao buscar usurios');
      const users = await response.json();

      const usuariosMap = {};
      users.forEach((user) => {
        usuariosMap[user.ID_USUARIO] = user.LOGIN;
      });
      setUsuarios(usuariosMap);
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      message.error('Erro ao buscar usuários.');
    }
  }, []);

  const alterarStatusPedido = async (ID_PEDIDO, STATUS) => {
    try {
      const DATA = new Date().toISOString(); // mantém UTC no envio
      const response = await fetch(`${Api_VariavelGlobal}/api/pedido/${ID_PEDIDO}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ STATUS, DATA }),
      });

      if (!response.ok) throw new Error('Erro ao atualizar o pedido');

      message.success(`Pedido ${ID_PEDIDO} concludo com sucesso!`);
      return true;
    } catch (error) {
      message.error('Erro ao aceitar o pedido.');
      return false;
    }
  };

  const fetchPedidosNovos = useCallback(async () => {
    try {
      const response = await fetch(`${Api_VariavelGlobal}/api/pedido/status/5`);
      if (response.status === 404) {
        setPedidosNovos([]);
        return;
      }
      if (!response.ok) throw new Error('Erro ao buscar pedidos');

      const data = await response.json();
      const pedidosArray = Array.isArray(data) ? data : [];
    const pedidosFormatados = pedidosArray
      .sort((a, b) => new Date(b.DATA) - new Date(a.DATA))
      .map((pedido) => ({
        ...pedido,
        TOTAL: formatarValor(pedido.TOTAL),
        DATA: formatarData(pedido.DATA),  // agora no padrão brasileiro
        PAGAMENTO: getTipoPagamento(Number(pedido.PAGAMENTO)),
      }));
  
      setPedidosNovos(pedidosFormatados);
    } catch (error) {
      setPedidosNovos([]);
    }
  }, []);

  const aceitarPedido = async (ID_PEDIDO) => {
    if (loadingPedido === ID_PEDIDO) return;

    setLoadingPedido(ID_PEDIDO);

    const pedidoAtual = pedidosNovos.find((p) => p.ID_PEDIDO === ID_PEDIDO);
    if (!pedidoAtual) {
      message.error('Pedido não encontrado.');
      setLoadingPedido(null);
      return;
    }

    const novoStatus = Number(pedidoAtual.STATUS) + 1;
    const sucesso = await alterarStatusPedido(ID_PEDIDO, novoStatus);

    if (sucesso) fetchPedidosNovos();

    setLoadingPedido(null);
  };

  useEffect(() => {
    fetchUsuarios();
    fetchPedidosNovos();
    const interval = setInterval(fetchPedidosNovos, 2000);
    return () => clearInterval(interval);
  }, [fetchUsuarios, fetchPedidosNovos]);

  return (
    <Col xs={24} sm={24} md={24}>
      <div style={{ padding: '10px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#52c41a',
            color: 'white',
            padding: '10px 15px',
            borderRadius: '8px',
            marginBottom: '15px',
            fontWeight: 'bold',
            fontSize: '16px',
          }}
        >
          <span>Em Entrega</span>
          <span>{pedidosNovos.length} Pedido(s)</span>
        </div>

        {pedidosNovos.length > 0 ? (
          <List
            itemLayout="horizontal"
            dataSource={pedidosNovos}
            renderItem={(pedido) => (
              <React.Fragment key={pedido.ID_PEDIDO}>
                <List.Item
                  style={{ padding: '10px 0' }}
                  actions={[
                    <Button
                      key="aceitar"
                      type="primary"
                      size="small"
                      loading={loadingPedido === pedido.ID_PEDIDO}
                      onClick={() => aceitarPedido(pedido.ID_PEDIDO)}
                    >
                      <ArrowRightOutlined />
                    </Button>,
                  ]}
                >
                  <List.Item.Meta
                    title={
                      <span style={{ fontWeight: 'bold' }}>
                        Pedido {pedido.ID_PEDIDO} - {pedido.TOTAL}
                      </span>
                    }
                    description={
                      <div style={{ fontSize: '14px' }}>
                        <div>
                          <strong>Usuário:</strong> {usuarios[pedido.ID_USUARIO] || 'Não informado'}
                        </div>
                        <div>
                          <strong>Pagamento:</strong> {pedido.PAGAMENTO}
                        </div>
                        <div>
                          <strong>Data:</strong> {pedido.DATA}
                        </div>
                      </div>
                    }
                  />
                </List.Item>
                <Divider style={{ margin: '8px 0' }} />
              </React.Fragment>
            )}
          />
        ) : (
          <p style={{ textAlign: 'center', marginTop: '20px' }}>Nenhum pedido</p>
        )}
      </div>
    </Col>
  );
};

export default PedidosEntrega;
